export function setAccount(ctx, account) {
    ctx.dispatch((state) => ({
        ...state,
        account: account,
    }));
}
export function setSignation(ctx, signation) {
    ctx.dispatch((state) => ({
        ...state,
        signation: signation,
    }));
}
